if(!customElements.get('product-main')) {
  class ProductMain extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.section;
      const productDataElement = this.matches('product-main')
        ? this.querySelector('[type="application/json"][data-product-json-main]')
        : this.querySelector('[type="application/json"][data-product-json]');
      this.productData = JSON.parse(productDataElement.textContent);
      this.variantsElement = this.querySelector('product-variants');
      this.sellingPlanElement = this.matches('product-main')
        ? this.querySelector('product-selling-plan[data-product-selling-plan-main]')
        : this.querySelector('product-selling-plan');
      this.quantityElement = this.querySelector('.quantity-input');
      this.badgesSale = this.querySelectorAll('.badge.sale');
      this.badgesSoldOut = this.querySelectorAll('.badge.sold-out');
      this.variantTitleElements = this.querySelectorAll('[data-variant-title]');
      this.addOnsElement = this.querySelector('product-add-ons');
      this.crossSellersElement = this.querySelector('product-cross-sellers');

      this.optionValues = {}
      const requiredOptionsSetting = ([] || []).concat(this.dataset.manualSelect ? this.dataset.manualSelect.split(',') : []).map(x=>x.trim());
      const requiredOptionsSettingUnique = [...new Set(requiredOptionsSetting)];
      this.requiredOptions = this.productData.options.filter(x=>(requiredOptionsSettingUnique.indexOf(x)>-1 || requiredOptionsSettingUnique.indexOf('*')>-1) && this.getOptionValues(x).length>1);
      if (this.requiredOptions.length > 0) {
        this.setAttribute('data-required', 'true');
      }
      if (this.quantityElement) {
        this.quantityElement.addEventListener('change', this.onQuantityElementChange.bind(this));
      }
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
    }

    getOptionValues(optionName) {
      if (!this.optionValues[optionName]) {
        function filterUnique(value, index, array) {
          return array.indexOf(value) === index;
        }
        var ix = this.productData.options.indexOf(optionName);
        this.optionValues[optionName] = this.productData.variants.map(v=>v['option'+(1+ix)]).filter(filterUnique);
      }
      return this.optionValues[optionName];
    }

    isSwatchSelected() {
      return this.requiredOptions.length == 0 || this.requiredOptions.length < this.productData.options.length;
    }

    required(option, newValue) {
      var ix = this.requiredOptions.indexOf(option);
      if (typeof(newValue)!='undefined') {
        if (ix > -1) {
          this.requiredOptions.splice(ix, 1);
          if (this.requiredOptions.length == 0) {
            this.setAttribute('data-required', 'false');
          }
          return false;
        }
      }
      return ix > -1;
    }

    getCurrentAddOns() {
      return this.addOnsElement ? this.addOnsElement.getCurrentAddOns() : null;
    }

    getCurrentVariant() {
      return this.variantsElement.getCurrentVariant();
    }
    getCurrentPlan() {
      return this.sellingPlanElement?.getCurrentPlan();
    }
    getQuantity() {
      return this.quantityElement ? this.quantityElement.value : 1;
    }
    onQuantityElementChange() {
      this.dispatchEvent(new CustomEvent('quantityChange', {detail: {"quantity":this.getQuantity()}}));
    }
    onVariantChange(event) {
      //lightweight update of elements that not worth creating their own components
      var variant = event.detail.variant;
      if (variant && Array.isArray(variant.options)) {
        this.querySelectorAll('[data-sticky-variant-summary-value]').forEach(element=>{
          var position = Number(element.dataset.stickyVariantSummaryValue);
          var value = variant.options[position - 1];
          if (typeof value != 'undefined') {
            element.textContent = value;
          }
        });
      }
      this.variantTitleElements.forEach(element=>{
        element.innerHTML = variant.title;
      });
      this.badgesSale.forEach(element=>{
        var sale = '';
        var percent = Math.floor((1 - variant.price / variant.compare_at_price) * 100);
        if (percent > 0) {
          sale = element.dataset.msgtpl.replace('[percent]', percent);
        }
        element.style.display = variant.available && sale ? '' : 'none';
        element.innerHTML = sale;
      });
      this.badgesSoldOut.forEach(element=>{
        element.style.display = variant.available ? 'none' : '';
      });}
  }
  customElements.define('product-main', ProductMain);

  class ComponentProductCardAtc extends ProductMain {
    constructor() {
      super()
      this.swatches = this.querySelector('.swatch-group')
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
      this.defaultImage = this.querySelector('.img.main').getAttribute('data-srcset');
      this.currentImageUrl = '';
      this.imageObserver = null;
      this.clickOutHandler = null;
      let imageContainer = this.querySelector('.image-container');
      if (imageContainer && imageContainer.querySelector('.hover-img')) {
        let hover = false;
        this.addEventListener('mouseleave', (e)=>{
          hover && (hover=false,imageContainer.classList.remove("hover"));
        });
        this.addEventListener('mousemove', (e)=>{
          let bounds = imageContainer.getBoundingClientRect();
          if (e.y>bounds.top && e.y<bounds.bottom && e.x>bounds.left && e.x<bounds.right) {
            hover || (hover=true,imageContainer.classList.add("hover"))
          } else {
            hover && (hover=false,imageContainer.classList.remove("hover"));
          }
        });
      }

      this.optionsButton = this.querySelector('.atc-options');
      if (this.optionsButton) {
        this.optionsButton.addEventListener('click', this.openOptions.bind(this));
      }

      this.quickViewBtn = this.querySelector('.quick-view-trigger')
      if(this.quickViewBtn) {
        this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this));
      }

      var self = this;
      if (self.classList.contains('colors-out')) {
        setTimeout(function() { //workaround on ajax call, the following code mistakenly inits ProductSwatch before ProductVariants
          var origSwatches = self.querySelector('product-swatch.color-swatches');
          if (origSwatches) {
            //need to duplicate the whole product-variants component
            var pv = origSwatches.closest('product-variants');
            var tag = pv.outerHTML.replace('name="id"', '');
            var wrapper = document.createElement('div');
            wrapper.style.display = 'none';
            //must insert as Element, not HTML, otherwise the component would be reconstructed
            self.querySelector('add-to-cart-form').insertAdjacentElement('beforebegin', wrapper);
            wrapper.innerHTML = tag;
            //move the swatches inside the add-to-cart-form component to use existing css.
            self.querySelector('add-to-cart-form').insertAdjacentElement('afterbegin', wrapper.querySelector('product-swatch.color-swatches'));
          }
        }, 10);
      }
      if (window.LinkPrefetch && window.LinkPrefetch.addHoverListener) {
        window.LinkPrefetch.addHoverListener(this);
      }
    }

    openOptions(e) {
      e.preventDefault()
      var container = this.querySelector('.atc-options-wrapper form');
      this.querySelector('.atc-options-wrapper').classList.add('open');
      $s.trapFocus(container);
      var self = this;
      if (!this.clickOutHandler) {
        this.querySelector('.close').addEventListener('click', this.closeOptions.bind(this));
      }
      this.clickOutHandler = function(evt) {
        if(container !== evt.target && !container.contains(evt.target)) {
          self.closeOptions.bind(self)();
        }
      }
      document.addEventListener('mousedown', this.clickOutHandler);
    }
    closeOptions() {
      this.querySelector('.atc-options-wrapper').classList.remove('open');
      document.removeEventListener('mousedown', this.clickOutHandler);
      $s.removeTrapFocus();
    }

    openQuickView(e) {
      e.preventDefault()
      $s.showLoadingOverlay();
      var qvUrl = this.quickViewBtn.dataset.url;
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          var enhancedDescription = section.querySelector('.enhanced-description');
          if (enhancedDescription && enhancedDescription.querySelector('.expandable-default-open')) {
            enhancedDescription.querySelector('.accordion.open').classList.remove('open');
            enhancedDescription.querySelector('[aria-expanded=true]').ariaExpanded = false;
            enhancedDescription.querySelector('.expandable-default-open').classList.remove('expandable-default-open');
          }
          $s.openModal(section, 'product-quick-view');
          $s.globalEval(section);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    onVariantChange(event) {
      super.onVariantChange(event);
      var variant = event.detail.variant;
      var image = variant.featured_media && super.isSwatchSelected() ? variant.featured_image : null;
      var img = this.querySelector('.img.main');
      var width = Math.ceil(img.width / 100) * 100;
      if (image && img.classList.contains('under-video')) {
        this.querySelector('.video-wrap').remove();
        img.classList.remove('under-video');
      }

      if (img.classList.contains('lazyload')) {
        img.setAttribute('data-srcset', image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage);
      } else {
        this.currentImageUrl = image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage;
        if (!this.imageObserver) {
          if (!img.classList.contains('lazyloaded')) {
            this.imageObserver = new MutationObserver(mutations => {
              if (img.classList.contains('lazyloaded')) {
                this.imageObserver.disconnect();
                this.imageObserver = null;
                img.setAttribute('srcset', this.currentImageUrl);
              }
            });
            var config = { attributes: true, attributeFilter: ['class']};
            this.imageObserver.observe(img, config);
          } else {
            img.setAttribute('srcset', this.currentImageUrl);
          }
        }
      }

      //update urls to variant
      var links = this.querySelectorAll('.product-card-url[href]');
      if (links.length > 0 && this.requiredOptions.length < this.productData.options.length) {
        var productUrl = new URL(links[0].getAttribute('href'), location.origin);
        productUrl.searchParams.set('variant', variant.id);
        links.forEach(link=>{
          link.setAttribute('href', productUrl.toString());
        });
        if (this.quickViewBtn) {
          this.quickViewBtn.dataset.url = productUrl.toString();
        }
      }
    }
  }
  customElements.define('product-card-atc', ComponentProductCardAtc);
}

if (!customElements.get('collapse-description')) {
  class ComponentCollapseDescription extends HTMLElement {
    constructor() {
      super();
      this.captionMore = this.dataset.captionMore;
      this.captionLess = this.dataset.captionLess;
      this.truncateChars = this.dataset.truncateChars ? parseInt(this.dataset.truncateChars) : 0;
      this.descriptionHtml = this.innerHTML ? this.innerHTML.replace(/<[^>]*>/g, '') : '';
      this.button = null;

      if (this.truncateChars > 0 && this.descriptionHtml.length > this.truncateChars) {
        this.classList.add('initialized')
        this.truncate()
      }
    }
    truncate () {
      const trunks = this.truncateString(this.descriptionHtml, this.truncateChars);
      this.innerHTML = trunks.map(trunk => `<span>${trunk}</span>`).join('');
      if (trunks.length > 1)
        this.addButton();
    }

    addButton() {
      this.button = document.createElement('button');
      this.button.classList.add('btn-collapse')
      this.button.innerHTML = this.captionMore;
      this.appendChild(this.button)
      this.button.addEventListener('click', this.onCollapse.bind(this))
    }

    onCollapse(event) {
      event.preventDefault();
      if (this.classList.contains('expanded')) {
        this.classList.remove('expanded');
        this.button.innerHTML = this.captionMore
      } else {
        this.classList.add('expanded')
        this.button.innerHTML = this.captionLess
      }
    }

    truncateString (string, chars) {
      if (typeof string !== 'string' || chars < 0) return [];
      if (string.length <= chars) return [string];
      const first = string.slice(0, chars);
      const second = string.slice(chars).trim();
      return second ? [first, second] : [first];
    }

  }
  customElements.define('collapse-description', ComponentCollapseDescription)
}

if(!customElements.get('product-card-add-on')) {
  class ProductCardAddOn extends HTMLElement {
    constructor() {
      super()
      this.addOns = document.querySelector('product-add-ons');
      this.quickViewBtn = this.querySelector('.quick-view-trigger');
      this.quickViewSection;
      if(this.quickViewBtn) {
        this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this));
      }
    }
    openQuickView(e) {
      e.preventDefault()
      $s.showLoadingOverlay();

      var qvUrl = this.quickViewBtn.dataset.url;
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          var sectionProdInformation = doc.querySelector('#product-information-qv');
          section.querySelector('.accordion-desc-qv').appendChild(sectionProdInformation)

          $s.openModal(section, 'product-quick-view');
          $s.globalEval(section);
          this.quickViewSection = section;

          if (this.classList.contains('added')) {
            this.quickViewSection.querySelector('.btn-qv-product-add-on').classList.add('added')
          }
          this.initButtonsAddOn()

        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    addAddOn(event) {
      event.preventDefault();
      if (this.addOns) {
        this.addOns.addProduct(event.currentTarget.dataset.product);
        event.currentTarget.closest('.btn-qv-product-add-on').classList.add('added')
        $s.closeModal()
      }
    }

    removeAddOn(event) {
      event.preventDefault();
        if (this.addOns) {
          this.addOns.removeProduct(event.currentTarget.dataset.product);
          event.currentTarget.closest('.btn-qv-product-add-on').classList.remove('added')
        }
    }

    initButtonsAddOn() {
      var btnAddOn = this.quickViewSection.querySelector('.btn-qv-add-on.btn-add');
      var btnRemoveAddOn = this.quickViewSection.querySelector('.btn-qv-add-on.btn-remove');
      btnAddOn.addEventListener('click', this.addAddOn.bind(this));
      btnRemoveAddOn.addEventListener('click', this.removeAddOn.bind(this));
    }
  }
  customElements.define('product-card-add-on', ProductCardAddOn);
}



if(!customElements.get('product-buttons')) {
  class ProductButtons extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.dynamicButtons = this.querySelector('.shopify-payment-button');
      this.mainAddButton = this.mainElement.querySelector('.btn.add');
      this.button = this.querySelector('.btn.add');
      if (this.button != this.mainAddButton) {
        this.button.addEventListener('click', (event)=>{
          event.preventDefault();
          event.stopImmediatePropagation();
          this.mainAddButton.click();
        });
      }

      this.mainElement.addEventListener('variantChange', (e)=>{
        var requiredBtn = this.querySelector('.btn.selection-required');
        if (this.required() && requiredBtn) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          requiredBtn.style.display = '';
          requiredBtn.innerHTML = this.requiredMessage;
        } else if(e.detail.variant && e.detail.variant.available) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.remove('hide');
          }
          this.button.style.display = '';
          this.showSoldOut(false);
          if (requiredBtn) requiredBtn.style.display = 'none';
      	} else {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          this.button.style.display = 'none';
          this.showSoldOut(true);
          if (requiredBtn) requiredBtn.style.display = 'none';
      	}
      });
    }

    showSoldOut(show) {
      var el = this.querySelector(':scope > .sold-out-message');
      if (!show) return el && el.remove();
      if (el) return;
      el = document.createElement('div');
      var btn = el;
      if (this.button.classList.contains('smaller')) { 
        el.className = 'sold-out-message';
        btn = el.appendChild(document.createElement('div'));
        btn.className = 'btn smaller disabled';
      } else {
        el.className = 'btn disabled sold-out-message';
      }
      btn.textContent = this.dataset.soldOut;
      this.button.after(el);
    }

    required() {
      if (this.mainElement.requiredOptions.length > 0) {
        this.requiredMessage = '';
        var label = this.mainElement.requiredOptions[0];
        var firstLetter = label[0].toLowerCase();
        var prep = 'aeiou'.indexOf(firstLetter)>-1 ? 'an' : 'a'; //english support only
        this.requiredMessage = lngg.product_main__select_option_label.replace('Select a ', 'Select ' + prep + ' ').replace(new RegExp(/{{ *option_name *}}/), label);
        return true;
      }
      return false;
    }
  }
  customElements.define('product-buttons', ProductButtons);
}

if(!customElements.get('product-sku')) {
  class ProductSKU extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
      	if(e.detail.variant) {
          if(e.detail.variant.sku) {
            this.closest('.module').style.display = 'block';
            this.innerHTML = e.detail.variant.sku;
          }else{
            this.closest('.module').style.display = 'none';
          }
      	}
      });
    }
  }
  customElements.define('product-sku', ProductSKU);
}

if(!customElements.get('product-gallery') && !customElements.get('product-thumbs')) {
  const getKeenSlideNumberLabel = (slider) => {
    let sliderDetails = slider.details();
    let sliderOptions = slider.options ? slider.options() : {};

    if (sliderDetails.slidesPerView >= sliderDetails.size) {
      return ``;
    }

    let currentSlide = sliderDetails.relativeSlide + 1;

    if (!sliderOptions.loop && !sliderOptions.centered && sliderDetails.relativeSlide + sliderDetails.slidesPerView >= sliderDetails.size) {
      currentSlide = sliderDetails.size;
    }

    return `${currentSlide} / ${sliderDetails.size}`;
  }

  class ProductMedia extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.itemsWrapper = this.querySelector('.items-wrapper');
      this.desktopStyle = this.dataset.desktop;
      this.desktopDots = this.dataset.desktopDots == 'true';
      this.desktopOrientation = this.dataset.desktopOrientation;
      this.mobileStyle = this.dataset.mobile;
      this.slider = false;

      this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this))
      window.addEventListener('mediaChange', this.onMediaChange.bind(this))
      setTimeout(()=>{
        this.onMediaChange();
      }, 10);
    }

    filterMedia(variant, additionalFilters) {
      this.mainElement.productData.media.forEach((media)=>{
        var show = true;
        if (media.alt && media.alt != "") {
          var alt = media.alt;
          if (alt.indexOf("|") > -1) {
            var altParts = alt.split("|")
            if (altParts.length > 1) alt = altParts[1]
          }
          var filter = alt.split(';');
          filter.forEach((f)=>{
            if(show) {
              var key = f.split(':')[0];
              var values = f.split(':')[1];
              if (key.trim() === 'Add-Ons') {
                var found = false;
                if (additionalFilters) {
                  if (values.split(',').sort((a, b) => a < b ? 1 : -1).filter(a => a).map(a => a.trim()).join('+') === additionalFilters.split(',').sort((a, b) => a < b ? 1 : -1).filter(a => a).map(a => a.trim()).join('+')) {
                    found = true;
                  }
                }
                show = found;
                /*
                values.split(',').forEach(value => {
                  if (additionalFilters && additionalFilters.split(',').includes(value.trim())) {
                    found = true;
                  }
                  show = found;
                })*/
              } else {
                var optionIndex = this.mainElement.productData.options.findIndex(x=>x==key.trim());
                if(optionIndex>=0 && values) {
                  var found = false;
                  values.split(',').forEach((value)=>{
                    if(variant.options[optionIndex]==value.trim()) {
                      found = true;
                    }
                  });
                  show = found;
                }
              }
            }
          });
        }
        if(show) {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'block';
        } else {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'none';
        }
      });
      if(this.slider) {
        this.slider.refresh();
      }
    }

    onVariantChange() {
    }

    onMediaChange() {
    }

    initSlider() {
    }

    removeSlider() {
      if(this.slider) {
        this.slider.destroy();
        this.slider = false;
        this.classList.remove('keen');
        this.itemsWrapper.classList.remove('keen-slider');
        this.querySelectorAll('.media-wrap, .thumb-wrap').forEach((slide)=>{
          slide.classList.remove('keen-slider-slide')
        });
      }
    }

    showItem(mediaId, animate=true) {
      if(this.slider) {
        var index = Array.from(this.itemsWrapper.querySelectorAll('.media-wrap, .thumb-wrap'))
          .filter(x=>$s.isVisible(x)).findIndex(x=>x.dataset.mediaId==mediaId);
        if(animate) {
          this.slider.moveToSlideRelative(index, true);
        } else {
          this.slider.moveToSlideRelative(index, true, 0);
        }
      }
    }
  }

  class ProductGallery extends ProductMedia {
    constructor() {
      super();
      this.mainElement.addEventListener('addOnsUpdated', this.onAddOnUpdated.bind(this))

      if(!this.closest('.tingle-modal')) {
        this.querySelectorAll('[data-file]').forEach((media)=>{
          media.addEventListener('click', (e)=>{
            var visibleItems = [];
            this.querySelectorAll('[data-media-id]').forEach((obj)=>{
              if($s.isVisible(obj)) {
                let element  = obj.querySelector('[data-file], video, iframe');
                if(element) {
                  visibleItems.push(element);
                }
              }
            });
            $s.photoSwipe(visibleItems, media);
          });
        });
        //3D Models
        this.querySelectorAll('[data-media-id].model-wrap').forEach((model)=>{
          model.addEventListener('click', (e)=>{
            $s.photoSwipe([model.querySelector('template').content.firstElementChild]);
          });
        });
      }

      this.classList.remove('loading');
    }

    onAddOnUpdated(e) {
      var variant = this.mainElement.getCurrentVariant()
      let addOnsFilter = e.detail?.length > 0 ? e.detail?.map(addOn => addOn.title).join(',') : 'NONE';
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant, addOnsFilter)
      }
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      var animate = e.detail.animate;
      var currentAddOns = this.mainElement.getCurrentAddOns();
      var addOnsFilter = currentAddOns && currentAddOns.length > 0 ? currentAddOns.map(addOn => addOn.title).join(',') : 'NONE';
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant, addOnsFilter);
        if(variant.featured_media && this.mainElement.isSwatchSelected()) {
          this.showItem(variant.featured_media.id, animate)
        }
      }
    }

    onMediaChange() {
      if($s.media.isSmall || this.desktopStyle=='carousel') {
        this.initSlider();
      } else {
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.media-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });

        var breakpoints = {};
        if(this.mobileStyle=='dots') {
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            dots: this.querySelector('.keen-dots')
          }
        } else if(this.desktopDots) {
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            dots: false
          }
        }
        if(this.querySelector('.keen-arrow')) {
          breakpoints['(min-width: '+(parseInt(window.breakpoints.small) + 0.001) +'rem)'] = {
            prevButton: this.querySelector('.keen-arrow.prev'),
            nextButton: this.querySelector('.keen-arrow.next')
          }
        }

        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: false,
          wheel: false,
          ...(this.desktopDots ? {dots: this.querySelector('.keen-dots')} : {}),
          slideChanged: (keen)=>{
            $s.pauseAllMedia(this);
            this.dispatchEvent(new CustomEvent('slideChanged', {detail: keen}));

            // This is added to handle the num of slides display for line shaped dots
            if (this.querySelector('.keen-dots') && this.querySelector('.keen-dots').classList.contains('line')) {
              var numSlides = this.querySelector('.keen-slide-numbers');
              if (numSlides) {
                numSlides.innerHTML = getKeenSlideNumberLabel(keen)
              }
            }
          },
          breakpoints
        });
      }
    }
  }
  customElements.define('product-gallery', ProductGallery);

  class ProductThumbs extends ProductMedia {
    constructor() {
      super();
      this.mainGallery = this.mainElement.querySelector('product-gallery');

      this.mainElement.addEventListener('addOnsUpdated', this.onAddOnUpdated.bind(this))

      this.querySelectorAll('[data-media-id]').forEach((media)=>{
        media.addEventListener('click', (e)=>{
          this.mainGallery.showItem(media.dataset.mediaId);
        });
      });

      this.mainGallery.addEventListener('slideChanged', (e)=>{
        var currentSlide = e.detail.currentSlide();
        if(currentSlide) {
          var currentMediaId = currentSlide.dataset.mediaId;
          var currentSlideElement = this.querySelector('.current-slide');
          if(currentSlideElement) {
            currentSlideElement.classList.remove('current-slide');
          }
          this.querySelector('[data-media-id="'+currentMediaId+'"]').classList.add('current-slide');
          this.showItem(currentMediaId);
        }
      });
    }


    onVariantChange(e) {
      var variant = e.detail.variant;
      var animate = e.detail.animate;
      var currentAddOns = this.mainElement.getCurrentAddOns();
      var addOnsFilter = currentAddOns && currentAddOns.length > 0 ? currentAddOns.map(addOn => addOn.title).join(',') : 'NONE';
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant, addOnsFilter);
        setTimeout(() => this.slider.moveToSlide(0, 500), 50)

      }
    }

    onMediaChange() {
      if(($s.media.isSmall && this.mobileStyle=='thumbnails') || ($s.media.isMediumUp && (this.desktopStyle=='carousel') )) {
        this.style.display = 'block';
        if (this.desktopOrientation == 'vertical' && this.slider) {
          this.removeSlider();
        }
        this.initSlider();
      } else {
        this.style.display = 'none';
        this.removeSlider();
      }
    }

    onAddOnUpdated(e) {
      var variant = this.mainElement.getCurrentVariant()
      let addOnsFilter = e.detail?.length > 0 ? e.detail?.map(addOn => addOn.title).join(',') : 'NONE';
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant, addOnsFilter);
        setTimeout(() => this.slider.moveToSlide(0, 500), 50)
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.thumb-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });
        var breakpoints = {};
        if (this.desktopOrientation == 'vertical') {
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            slidesPerView: 5,
            spacing: 10,
            centered: false,
            vertical: false
          };
        } else {
          breakpoints['(max-width: '+window.breakpoints.medium+')'] = {
            slidesPerView: 4,
            spacing: 10,
            centered: false,
            vertical: false
          };
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            slidesPerView: 5,
            spacing: 10,
            centered: false,
            vertical: false
          };
        }
        var thumbsElement = this;
        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          centered: false,
          slidesPerView: 7,
          spacing: 15,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          breakpoints,
          ...(this.desktopOrientation=='vertical' ? {
            vertical: true,
            slidesPerView: () => {
              var spacing = 15;
              if (!thumbsElement.offsetWidth || !thumbsElement.offsetHeight) return 5;
              return Math.max(1, Math.floor((thumbsElement.offsetHeight + spacing) / (thumbsElement.offsetWidth + spacing)));
            }
          } : {})
        });
        if (this.desktopOrientation == 'vertical') {
          requestAnimationFrame(() => {
            if (this.slider) this.slider.refresh();
          });
        }
      }
    }
  }
  customElements.define('product-thumbs', ProductThumbs);
}

if(!customElements.get('product-price')) {
  class ProductPrice extends HTMLElement {
  	constructor() {
      super();
      this.startingAt = this.dataset.startingAt;
      this.endingAt = this.dataset.endingAt;
      this.mainElement = this.closest('.product-main-element');
      this.addOnsElement = document.querySelector('product-add-ons')
      this.crossSellersElement = document.querySelector('product-cross-sellers')
      this.finalPriceElement = this.querySelector('.final');
      this.comparePriceElement = this.querySelector('.compare');
      this.includeAddOns = this.dataset.includeAddons == 'true';
      this.includeCrossSellers = this.dataset.includeCrosssellers == 'true';
      this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : false
      this.discountDisplayType = this.dataset.discountDisplayType;
      this.discountDisplayAmount = this.dataset.discountDisplayAmount;
      this.showDiscountDisplay = this.discountDisplayType && this.discountDisplayAmount;

      if(this.mainElement && this.mainElement.classList.contains('product-card')){
        var originalPricePrefix = '<span class="visually-hidden">Original price: </span>'
        var finalPricePrefix = '<span class="visually-hidden">. Final price: </span>'
      }else{
        var originalPricePrefix = '<span class="visually-hidden">Original price: </span>'
        var finalPricePrefix = '<span class="visually-hidden">. Final price: </span>'
      }

      this.listenEvents = ['variantChange','sellingPlanChange','addOnsUpdated','crossSellersUpdated'];

      if (this.multiplyQuantity)
        this.listenEvents.splice(1, 0, 'quantityChange');

      this.listenEvents.forEach((event) => {
        if (!this.mainElement) return;
        this.mainElement.addEventListener(event, (e)=>{
          var data = this.mainElement.getCurrentPlan() || this.mainElement.getCurrentVariant();
          var dataAddOns = this.includeAddOns ? this.addOnsElement && this.addOnsElement.getAddOns ? this.addOnsElement.getAddOns() : [] : null;
          var dataCrossSellers = this.includeCrossSellers ? this.crossSellersElement && this.crossSellersElement.getCrossSellers ? this.crossSellersElement.getCrossSellers() : [] : null;

        	if(data) {

            var price = data.price;
            var priceAddOns = 0;
            var priceCrossSellers = 0;
            var compareAtPrice = data.compare_at_price;
            var quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;

            if (this.includeAddOns && dataAddOns && dataAddOns.length > 0) {
              priceAddOns = dataAddOns.reduce((tot, item) => {
                var itemPrice = item.price;
                if (item.hasDiscount) {
                  // calculate item w/discount
                  var itemPriceDiscount = this.calculateDiscount(itemPrice, itemPrice, quantity, item.discountType, parseFloat(item.discountAmount));
                  itemPrice = itemPriceDiscount.displayPrice;
                }
                return tot + itemPrice;
              }, 0)
              compareAtPrice += + priceAddOns; //dataAddOns.reduce((tot, item) => tot + item.price, compareAtPrice)
            }

            if (this.includeCrossSellers && dataCrossSellers && dataCrossSellers.length > 0) {

              priceCrossSellers = dataCrossSellers.reduce((tot, item) => {
                var itemPrice = item.price;
                if (item.hasDiscount) {
                  // calculate item w/discount
                  var itemPriceDiscount = this.calculateDiscount(itemPrice, itemPrice, quantity, item.discountType, parseFloat(item.discountAmount));
                  itemPrice = itemPriceDiscount.displayPrice;
                }
                return tot + itemPrice;
              }, 0);
              compareAtPrice += priceCrossSellers;
            }


        		this.finalPriceElement.innerHTML = (this.startingAt ? `${this.startingAt} ` : ``) + $s.formatMoney((price + priceAddOns + priceCrossSellers) * quantity).replace('.00','') + (this.endingAt ? `${this.endingAt} ` : ``);

            if(compareAtPrice > price) {
              this.comparePriceElement.classList.remove('hide');
              this.comparePriceElement.innerHTML = originalPricePrefix + $s.formatMoney(compareAtPrice * quantity).replace('.00','');
        		  this.finalPriceElement.innerHTML = (this.startingAt ? `${this.startingAt} ` : ``) + finalPricePrefix + $s.formatMoney((price + priceAddOns + priceCrossSellers) * quantity).replace('.00','') + (this.endingAt ? `${this.endingAt} ` : ``);
            } else if (this.showDiscountDisplay) {
              var discountResults = this.calculateDiscount(price, compareAtPrice, quantity, this.discountDisplayType, this.discountDisplayAmount);
              var displayCompareAtPrice = discountResults.displayCompareAtPrice + priceAddOns + priceCrossSellers;
              var displayPrice = discountResults.displayPrice + priceAddOns + priceCrossSellers;

              this.comparePriceElement.classList.remove('hide');
              this.comparePriceElement.innerHTML = originalPricePrefix + $s.formatMoney(displayCompareAtPrice).replace('.00','');
        		  this.finalPriceElement.innerHTML = (this.startingAt ? `${this.startingAt} ` : ``) + finalPricePrefix + $s.formatMoney(displayPrice).replace('.00','') + (this.endingAt ? `${this.endingAt} ` : ``);
            } else {
              this.comparePriceElement.classList.add('hide');
              this.comparePriceElement.innerHTML = '';
            }
        	} else {
        		this.finalPriceElement.innerHTML = '';
            this.comparePriceElement.innerHTML = '';
        	}
          this.mainElement.dispatchEvent(new CustomEvent('priceChange', {detail: {price: price * quantity}}));
        });
      });
    }

    calculateDiscount(price, compareAtPrice, quantity, discountDisplayType, discountDisplayAmount) {
      var totalFinalPrice = price * quantity;
      var totalFinalCompareAtPrice = compareAtPrice * quantity;
      var displayPrice = totalFinalPrice;
      var displayCompareAtPrice = totalFinalCompareAtPrice;
      if (discountDisplayType === 'fixed') {
        displayCompareAtPrice = totalFinalPrice;
        displayPrice = totalFinalPrice - (discountDisplayAmount * 100);
      } else if (discountDisplayType === 'percentage') {
        displayCompareAtPrice = totalFinalPrice;
        displayPrice = totalFinalPrice * (1 - (discountDisplayAmount * .01));
      }
      return {
        displayCompareAtPrice,
        displayPrice
      }
    }
  }
  customElements.define('product-price', ProductPrice);
}

if(!customElements.get('product-variants')) {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.mainElement.variantsInstances = (this.mainElement.variantsInstances || 0) +1;
      this.instanceIndex = this.mainElement.variantsInstances;
      this.variantInput = this.querySelector('[data-variant-id]');
      this.options = this.querySelectorAll('[data-option]');
      this.swatchImg = this.querySelector('product-swatch[data-use-img="true"]');
      this.variantsInfo = this.dataset.info ? JSON.parse(this.dataset.info) : null;
      this.mainElement.addEventListener('variantChange', (event)=> {
        if (this.variantInput.value != event.detail.variant.id) {
          this.setVariant(event.detail.variant);
        }
      })

      this.bindOptions();
      setTimeout(()=>{
        this.variantChange(this.getCurrentVariant(), false);
        this.bindInfoElements();
      }, 10);
    }

    getOptionInfo(optionName) {
      return (this.variantsInfo ? this.variantsInfo.find(x=>x.title==optionName) : null) || {};
    }

    getOptionInfoIcon(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.description) {
        html = `
          <div class="option-info-icon">
            <button type="button" class="btn-open">?</button>
            <div class="option-info-content animation">${info.description}</div>
          </div>
        `;
      }

      return html;
    }
    getOptionInfoLink(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.link_text) {
        if (info.link_target_image) {
          html = `
            <button type="button" class="option-info-link link" data-image-width="${info.link_target_image_native_width}" data-image-height="${info.link_target_image_native_height}" data-image="${info.link_target_image}" data-width="${info.link_target_image_width}">${info.link_text}</button>
          `;
        } else {
          html = `
            <a class="option-info-link link" href="${info.link_target_url}" target="_blank">${info.link_text}</a>
          `;
        }

      }

      return html;
    }

    getCurrentVariant() {
      return this.mainElement.productData.variants.find(x=>x.id==this.variantInput.value)
    }

    setVariant(variant) {
      if(typeof variant !== 'object') {
        variant = this.mainElement.productData.variants.find(x=>x.id==variant);
      }
      if(variant) {
        this.refreshOptions(-1, variant);
        this.variantChange(variant);
      }
    }

    variantChange(variant, animate=true) {
      if(variant) {
        this.variantInput.value = variant.id;
      } else {
        this.variantInput.value = '';
      }
      this.previousVariant = variant;
      this.variantInput.dispatchEvent(new Event('change', {bubbles: true}))
      this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant, animate}}));

      if (this.swatchImg) {
          //var variant = this.mainElement.productData.variants.
          var options = ['option1', 'option2', 'option3'];
          var imgOption = options.splice(this.swatchImg.dataset.option/1 -1 ,1);
          this.swatchImg.querySelectorAll('[type="radio"]').forEach(radio=>{
            var label = radio.parentNode.querySelector('.label-inner');

            var matchingVariant = this.mainElement.productData.variants.find(v=>v[imgOption]==radio.value && v[options[0]]==variant[options[0]] && v[options[1]]==variant[options[1]]);
            if (!matchingVariant) {
              matchingVariant = this.mainElement.productData.variants.find(v=>v[imgOption]==radio.value);
            }
            let img = label.querySelector('img');
            if (matchingVariant.featured_image) {
              if (!img) {
                img = document.createElement('img');
                img.loading = 'lazy';
                img.width = 80;
                img.height = 80;
                img.alt = '';
                label.appendChild(img);
              }
              img.src = $s.imgUrlFilter(matchingVariant.featured_image.src, '80x');
              img.style.display = '';
            } else {
              if (img) {
                img.style.display = 'none';
              }
            }
          });

      }

    }

    calculateNewVariant(optionChanged, value) {
      var newVariants = this.mainElement.productData.variants;
      this.mainElement.productData.options.forEach((option, index)=>{
        if(optionChanged==index) {
          newVariants = newVariants.filter(x=>x.options[index]==value);
        } else {
          var tmpNewVariants = newVariants.filter(x=>x.options[index]==this.previousVariant.options[index]);
          if(tmpNewVariants.length==0) {
            tmpNewVariants = newVariants.filter(x=>x.options[index]==newVariants[0].options[index]);
          }
          newVariants = tmpNewVariants;
        }
      });
      return newVariants[0];
    }

    bindOptions() {
      this.options.forEach((element)=>{
        element.addEventListener('change', (e)=>{
          let optionIdx = element.dataset.option-1;
          let variant = this.calculateNewVariant(optionIdx, e.target.value);
          this.refreshOptions(element.dataset.option-1, variant);
          this.variantChange(variant);
        });
      });
    }

    bindInfoElements() {
      this.options.forEach((element)=>{
        var infoIcon = element.querySelector('.option-info-icon');
        var infoLink = element.querySelector('button.option-info-link');
        if (infoIcon) {
          $s.initFloatingPanel({container: infoIcon});
        }
        if (infoLink) {
          infoLink.addEventListener('click', (e)=>{
            var imageWidthPX = parseFloat(getComputedStyle(document.documentElement).fontSize) * infoLink.dataset.width;
            var html = `
              <div class="option-info-popup-content" style="width: ${infoLink.dataset.width}rem">
                <img src="${infoLink.dataset.image + (infoLink.dataset.image.indexOf('?')==-1 ? '?' : '&') + 'width='+imageWidthPX}" width="${infoLink.dataset.imageWidth}" height="${infoLink.dataset.imageHeight}" />
              </div>
            `;
            $s.openModal(html, 'option-info-popup');
          });
        }
      });
    }

    getOptionValues(currentVariant) {
      var options = [];
      this.mainElement.productData.options.forEach((option, index)=>{
        if(index==0) {
          var optionValues = this.mainElement.productData.variants.map((variant)=>{return {
            value: variant.options[index],
            available: variant.available
          }});
        }
        if(index==1) {
          var optionValues = this.mainElement.productData.variants.filter(x=>x.options[0]==currentVariant.option1).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available
          }});
        }
        if(index==2) {
          var optionValues = this.mainElement.productData.variants.filter(
            x=>x.options[0]==currentVariant.option1 && x.options[1]==currentVariant.option2
          ).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available
          }});
        }
        var optionValuesUnique = [];
        optionValues.forEach((option, key)=>{
          if(!optionValuesUnique.find(x=>x.value==option.value)) {
            if(option.available) {
              optionValuesUnique.push(option);
            } else {
              if(!optionValues.find((x,y)=>y!=key && x.available && x.value==option.value)) {
                optionValuesUnique.push(option);
              }
            }
          }
        });
        options.push(optionValuesUnique);
      });
      return options;
    }

    refreshOptions(updateOptionIndex=-1, currentVariant) {
      var optionValues = this.getOptionValues(currentVariant);
      this.options.forEach((element)=>{
        let index = element.dataset.option - 1;
        if(index > updateOptionIndex) {
          element.buildOptions(optionValues[index], currentVariant.options[index]);
        }
        var optionValueElement = element.querySelector('.option-value');
        if(optionValueElement) {
          optionValueElement.innerHTML = currentVariant.options[index];
        }
      });
    }
  }
  customElements.define('product-variants', ProductVariants);
}

if(!customElements.get('product-variant-edit')) {
  class ProductVariantEdit extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.toggles = this.querySelectorAll('.toggle');
      this.toggles.forEach(btn=>{btn.addEventListener('click', this.onToggle.bind(this))});
      this.editing = false;
    }
    onToggle() {
      this.editing = !this.editing;
      var divVariants = this.querySelector('.variants');
      var divInfo = this.querySelector('.info');
      if (this.editing) {
        $s.expand([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.add('open')});
      } else {
        $s.collapse([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.remove('open')});
      }
    }
  }
  customElements.define('product-variant-edit', ProductVariantEdit);
}

if(!customElements.get('product-swatch')) {
  class ProductSwatch extends HTMLElement {
  	constructor() {
      super();
      this.colorSwatchesOptions = ["Color","Griddle (Color)","Softflex™ Cover (Color)","Grill (Color)","Model P Smart Pizza Oven (Color)","Softflex™ Pizza Cart Cover (Color)","Softflex™ Pizza Oven Cover (Color)","Model G Dual Zone Electric Grill (Color)","Model G2 Electric Grill (Color)","Model G+ Electric Grill (Color)","SoftFlex™ Grill and Griddle Cover (Color)","Model P+ Electric Pizza Oven (Color)"]
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.displayLabel = this.dataset.displayLabel || this.label;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';
      this.setAttribute('aria-labelledby', `swatchgroup-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`);

      this.buildOptionSelector();
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    escapeHtml(value) {
      return String(value).replace(/[&<>"']/g, character => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      })[character]);
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];
    	var optionElement = document.createElement('div');
      var mainElementId = this.mainElement.dataset.productId;
      var optionNameHandle = $s.handleize(this.label);
  		var html = `
        <div class="option-name">
          ${this.infoIcon}
          <span id="${this.getAttribute('aria-labelledby')}"><strong>${this.escapeHtml(this.displayLabel)}:</strong> </span>
          <span aria-hidden="true" class="option-value">${defaultValue}</span>
          ${this.infoLink}
        </div>
        <div class="swatch-group flex flex-wrap"></div>
  		`;
  		this.innerHTML = html;
  		this.buildOptions(optionValues, defaultValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
      if (options.length > 0) {
        this.setAttribute('role', 'radiogroup');
      }
  		options.forEach((option, index)=>{
        var optionNameHandle = $s.handleize(this.label);
        var optionValueHandle = $s.handleize(option.value);
        var id = `swatch-${this.optionNumber}-${$s.handleize(option.value)}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`;
        var soldOut = (!option.available ? '<span class="visually-hidden"> (Sold Out)</span>' : '');

  			html += `
          <div class="swatch" data-available="${option.available}">
            <input type="radio" id="${id}" name="swatch-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}" value="${$s.escapeDomAttribute(option.value)}" />
            <label for="${id}">
              <div class="check">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <g id="icon-check">
                    <path id="Icon" d="M4.16669 10.8333L7.50002 14.1667L15.8334 5.83334" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </g>
                </svg>
              </div>
              <div class="label-inner flex align-items-center justify-content-center animation ${this.colorSwatchesOptions.indexOf(this.label)>-1 ? 'color-'+optionValueHandle : ''} ${optionNameHandle}-${optionValueHandle}">
              	<span>${option.value}${soldOut}</span>
              </div>
            </label>
          </div>
  			`;
  		});
  		var group = this.querySelector('.swatch-group');
  		group.innerHTML = html;

      if (this.required()) {
        this.setAttribute('data-required', 'true');
        group.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
        }, {once: true})
      } else {
        this.setAttribute('data-required', 'false');
        if(defaultValue && group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]')) {
          group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]').checked = true;
        } else {
          group.querySelector('input').checked = true;
        }
      }
    }
  }
  customElements.define('product-swatch', ProductSwatch);
}

if(!customElements.get('product-dropdown')) {
  class ProductDropdown extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';

      this.buildOptionSelector();

      if (this.required()) {
        var select = this.querySelector('select');
        this.setAttribute('data-required', 'true');
        select.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
          select.querySelector('[disabled]').remove();
        }, {once: true})
      }
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];

      var optionId = 's-' + this.mainElement.sectionId+'-option-'+this.optionNumber + '-' + this.variantsElement.instanceIndex;
      var optionElement = document.createElement('div');
      var html = `
        <label class="option-name small-label" for="${optionId}">
        ${this.infoIcon}${this.label}:
        ${this.infoLink}
        </label>
        <div class="field">
          <svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path d="M27,10,16,22,5,10"/></svg>
          <select id="${optionId}" name="swatch-${optionId}"></select>
        </div>
      `;
      this.innerHTML = html;
      this.buildOptions(optionValues, defaultValue);
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
      if (this.required()) {
  			html += `<option value="${defaultValue || ''}" disabled selected>${lngg.general__forms__select_option_label}</option>`;
      } else {
        this.setAttribute('data-required', 'false');
      }
  		options.forEach((option, index)=>{
  			let soldOut = (!option.available ? lngg.product_main__sold_out_option_value : '');
  			html += `<option value="${$s.escapeDomAttribute(option.value)}">${option.value}${soldOut}</option>`;
  		});
  		var select = this.querySelector('select');
  		select.innerHTML = html;

  		if(defaultValue) {
    		var newValueIndex = Array.from(select.options).findIndex(x=>x.value==defaultValue);
    		if(newValueIndex>=0) {
    			select.selectedIndex = newValueIndex;
    		}
  		}
    }
  }
  customElements.define('product-dropdown', ProductDropdown);
}

if(!customElements.get('product-model')) {
  class ProductModel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = document.querySelector('.product-main-element[data-product-id="'+this.dataset.productId+'"]');

      window.Shopify.loadFeatures([{
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXr.bind(this)
      }]);
    }

    setupShopifyXr() {
      if(!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', ()=>{
          this.setupShopifyXr();
        });
      } else {
        window.ShopifyXR.addModels(this.mainElement.productData.media.filter(x=>x.media_type=='model'));
        setTimeout(()=>{
          window.ShopifyXR.setupXRElements();
        }, 100);
      }
    }
  }
  customElements.define('product-model', ProductModel);
}

if(!customElements.get('product-sticky-panel')) {
  class ProductStickyPanel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.scrollHandler = $s.throttle(this.onScroll.bind(this), 50);
      this.positionElement = this.mainElement.querySelector('.product-sticky-panel-position-placeholder');
      this.optionsTrigger = this.querySelector('.btn-options-trigger');
      this.optionsPanel = this.querySelector('.mobile-options');
      this.initOptions()
    }

    initOptions () {
      if (!this.optionsTrigger || !this.optionsPanel) {
        return;
      }
      this.optionsTrigger.addEventListener('click', event => {
        event.preventDefault()
        if (this.optionsPanel.classList.contains('open')) {
          event.currentTarget.classList.add('active')
          this.optionsPanel.classList.remove('open')
        } else {
          event.currentTarget.classList.remove('active')
          this.optionsPanel.classList.add('open')
        }
      })
    }

    connectedCallback() {
      if (this.positionElement) {
        window.addEventListener('scroll', this.scrollHandler);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.scrollHandler);
    }

    onScroll(event) {
      var bounds = this.positionElement.getBoundingClientRect();
      if (bounds.bottom < 0) {
        if (!this.showing) {
          this.classList.add('open');
          this.showing = true;
        }
      } else {
        if (this.showing) {
          this.classList.remove('open');
          this.showing = false;
        }
      }

    }

  }
  customElements.define('product-sticky-panel', ProductStickyPanel);
}

if(!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
        if(e.detail.variant && e.detail.variant.available) {
          this.fetchAvailability(e.detail.variant.id);
        } else {
          this.innerHTML = '';
        }
      });
    }

    fetchAvailability(variantId) {
      let rootUrl = routes.root_url;
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup_availability`;

      $s.get({
        url: variantSectionUrl,
        success: (data)=>{
          this.innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section').innerHTML;
          this.bindEvents();
        },
        error: ()=>{
          this.innerHTML = '';
        }
      });
    }

    bindEvents() {
      let button = this.querySelector('.pickup-popup-trigger');
      if(button) {
        button.addEventListener('click', ()=>{
          $s.openModal(this.querySelector('.pickup-availability-info'), 'pickup-availability-info-modal');
        });
      }
    }
  }
  customElements.define('pickup-availability', PickupAvailability);
}



